export default class GenericPositionalSystem {
    static meters_per_kilometer = 1000;

    constructor(systemID, route, position, subposition, sources) {
        this.system = systemID;
        this.route = route;
        this.position = position;
        this.subposition = subposition;
        this.sources = sources;
        this.sign = position >= 0 ? 1 : -1;
        if (this.sign < 0) {
            position = Math.abs(position);
        }
        this.kilometer = Math.floor(position / GenericPositionalSystem.meters_per_kilometer);
        this.meter = Math.floor(position - this.kilometer * GenericPositionalSystem.meters_per_kilometer);
    }

    static display_formats = {
        route_id_position: "Route ID Kilometers",
    };

    static display_fields = {};

    static from_fields(system_id, display_format, fields) {
        if (display_format === "track_id_position") {
            const position = fields.POSITION;
            return new GenericPositionalSystem(system_id, fields.ROUTE, position, fields.TRACK, []);
        }
    }

    to_string(_display_format, _datum_offsets) {
        const stringFormat = `Route: ${this.route}, ${this.to_position_string()}`;
        return stringFormat;
    }

    field_value(field, _datum_offsets) {
        switch (field) {
            case "ROUTE":
                return this.route;
            case "KILOMETER":
                return this.kilometer;
            case "METER":
                return this.meter;
            case "TRACK":
                return this.subposition || null;
            default:
                return null;
        }
    }

    fields(display_format) {
        return GenericPositionalSystem.fields(display_format);
    }

    static fields(_displayFormat) {
        return ["ROUTE", "KILOMETER", "METER", "TRACK"];
    }

    displayFields(display_format) {
        return GenericPositionalSystem.displayFields(display_format);
    }

    static displayFields(_displayFormat) {
        return ["ROUTE", "TRACK", "KILOMETER", "METER"];
    }

    to_position_string() {
        return `${this.kilometer}km ${this.meter}m`;
    }
}
